/**
 * Header 5001 — BDU site header (logo + phone + WhatsApp + Apply).
 *
 * Every field maps to a column the `header` table already has, so this variant needed
 * no new storage: the phone/logo columns come from Header 5, the whatsapp_* ones from
 * Header 7, and the CTA reuses the shared button_* columns.
 */

export const HEADER_5001_CONSTANTS = {
  HEADER_FIELDS_CONFIG: [
    {
      fieldName: "background_color",
      label: "Bar background",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "show_logo",
      label: "Show logo",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      defaultValue: true,
    },
    {
      fieldName: "logo_image",
      label: "Logo",
      value: "",
      valueType: "string",
      filedType: "IMAGE",
      defaultValue: "",
    },
    {
      fieldName: "logo_alt_text",
      label: "Logo alt text",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "BDU University",
      defaultValue: "",
    },
    {
      fieldName: "phone_number",
      label: "Phone line",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Phone NO. +91-8956667205",
      helperText:
        "Shown exactly as typed, label included. The tel: link uses the digits in it.",
      defaultValue: "",
    },
    {
      fieldName: "phone_text_color",
      label: "Phone text & icon colour",
      value: "#272323",
      valueType: "string",
      filedType: "COLOR",
      defaultValue: "#272323",
    },
    {
      fieldName: "phone_icon",
      label: "Phone icon (optional)",
      value: "",
      valueType: "string",
      filedType: "IMAGE",
      helperText: "Leave blank for the built-in handset glyph.",
      defaultValue: "",
    },
    {
      fieldName: "phone_icon_alt",
      label: "Phone icon alt text",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      defaultValue: "",
    },
    {
      fieldName: "whatsapp_show",
      label: "Show WhatsApp button",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      defaultValue: true,
    },
    {
      fieldName: "whatsapp_button_text",
      label: "WhatsApp button text",
      value: "WhatsApp Chat",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "WhatsApp Chat",
      defaultValue: "WhatsApp Chat",
    },
    {
      fieldName: "whatsapp_number",
      label: "WhatsApp number",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "+91-8956667205",
      helperText: "Used to build the chat link when no explicit link is set.",
      defaultValue: "",
    },
    {
      fieldName: "whatsapp_link",
      label: "WhatsApp link (optional)",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "https://api.whatsapp.com/send/?phone=…",
      defaultValue: "",
    },
    {
      fieldName: "whatsapp_button_color",
      label: "WhatsApp button fill",
      value: "#4CAF51",
      valueType: "string",
      filedType: "COLOR",
      defaultValue: "#4CAF51",
    },
    {
      fieldName: "whatsapp_button_text_color",
      label: "WhatsApp button text colour",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "whatsapp_icon",
      label: "WhatsApp icon (optional)",
      value: "",
      valueType: "string",
      filedType: "IMAGE",
      helperText: "Leave blank for the built-in WhatsApp glyph.",
      defaultValue: "",
    },
    {
      fieldName: "apply_button_text",
      label: "Apply button text",
      value: "Apply",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Apply",
      helperText: "Opens the lead form popup. Leave blank to hide the button.",
      defaultValue: "Apply",
    },
    {
      fieldName: "button_color",
      label: "Apply button fill",
      value: "#BE2330",
      valueType: "string",
      filedType: "COLOR",
      helperText: "A CSS gradient works here too.",
      defaultValue: "#BE2330",
    },
    {
      fieldName: "button_text_color",
      label: "Apply button text colour",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "sticky_to_top",
      label: "Stick to top while scrolling",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      defaultValue: true,
    },
    {
      fieldName: "show_bar_shadow",
      label: "Drop shadow under the bar",
      value: false,
      valueType: "boolean",
      filedType: "TOGGLE",
      defaultValue: false,
    },
    {
      fieldName: "show_on_mobile",
      label: "Show on mobile",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      helperText:
        "The phone line and WhatsApp button are desktop-only either way; mobile keeps logo + Apply.",
      defaultValue: true,
    },
    {
      fieldName: "status",
      label: "Status",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      defaultValue: true,
    },
  ],
};
